import styled from 'styled-components/macro'
import { Container } from 'components/core/layout'

export const StyledContainer = styled(Container)`
  max-width: 420px;
  width: 100%;
`
